// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-font: "Lato";
  --secondary-font: "Open Sans";
}

.heading1,
.heading3,
.heading4 {
  font-family: var(--primary-font);
  font-weight: 800;
  letter-spacing: 0px;
}
.heading1 {
  font-size: 48px;
  line-height: 58px;
}
.heading2 {
  font-family: var(--primary-font);
  font-size: 32px;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: 0px;
}
.heading3 {
  font-size: 24px;
  line-height: 29px;
}
.heading4 {
  font-size: 20px;
  line-height: 24px;
}

.labelLarge,
.labelMediumSemiBold {
  font-family: var(--secondary-font);
  font-weight: 600;
}
.labelLarge {
  font-size: 20px;
  line-height: 27px;
  letter-spacing: 0px;
}
.labelMediumBold,
.labelSmall {
  font-family: var(--secondary-font);
  font-weight: 700;
  letter-spacing: 0px;
}
.labelMediumBold {
  font-size: 16px;
  line-height: 22px;
}
.labelMediumSemiBold {
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 1px;
}
.labelSmall {
  font-size: 14px;
  line-height: 19px;
}
.bodyRegular,
.bodySmall {
  font-family: var(--secondary-font);
  font-weight: 400;
  letter-spacing: 0px;
}
.bodyRegular {
  font-size: 16px;
  line-height: 30px;
}
.bodySmall {
  font-size: 14px;
  line-height: 19px;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/Fonts.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;;EAGE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;;EAEE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[":root {\n  --primary-font: \"Lato\";\n  --secondary-font: \"Open Sans\";\n}\n\n.heading1,\n.heading3,\n.heading4 {\n  font-family: var(--primary-font);\n  font-weight: 800;\n  letter-spacing: 0px;\n}\n.heading1 {\n  font-size: 48px;\n  line-height: 58px;\n}\n.heading2 {\n  font-family: var(--primary-font);\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 38px;\n  letter-spacing: 0px;\n}\n.heading3 {\n  font-size: 24px;\n  line-height: 29px;\n}\n.heading4 {\n  font-size: 20px;\n  line-height: 24px;\n}\n\n.labelLarge,\n.labelMediumSemiBold {\n  font-family: var(--secondary-font);\n  font-weight: 600;\n}\n.labelLarge {\n  font-size: 20px;\n  line-height: 27px;\n  letter-spacing: 0px;\n}\n.labelMediumBold,\n.labelSmall {\n  font-family: var(--secondary-font);\n  font-weight: 700;\n  letter-spacing: 0px;\n}\n.labelMediumBold {\n  font-size: 16px;\n  line-height: 22px;\n}\n.labelMediumSemiBold {\n  font-size: 16px;\n  line-height: 18px;\n  letter-spacing: 1px;\n}\n.labelSmall {\n  font-size: 14px;\n  line-height: 19px;\n}\n.bodyRegular,\n.bodySmall {\n  font-family: var(--secondary-font);\n  font-weight: 400;\n  letter-spacing: 0px;\n}\n.bodyRegular {\n  font-size: 16px;\n  line-height: 30px;\n}\n.bodySmall {\n  font-size: 14px;\n  line-height: 19px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
